<template>
	<v-card>
		<v-card-title>
			<div><span class="headline">لاگ تغییر وضعیت های درخواست</span></div>
			<v-spacer />
			<v-btn @click="$emit('close')" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<div>
				<v-row>
					<v-col cols="11">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="1">
						<export-excel :items="items" :headers="headers" :fileName="excelFileName">
						</export-excel>
					</v-col>
					<v-col cols="12">
						<v-data-table :headers="headers" :loading="loading" :items="items" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
							<template v-slot:item.dateTime_Persian="{ item }">
								<div>{{ item.dateTime_Persian.date }}</div>
								<div>{{ item.dateTime_Persian.time }}</div>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import { emptyId } from '@/util/emptyId'

export default {
	name: 'ChangeStatusHistory',
	props: {
		loanRequestId: { type: String },
	},
	data() {
		return {
			errorMessages: '',
			search: '',
			loading: false,
			headers: [
				{
					text: 'کاربر',
					align: 'start',
					sortable: true,
					value: 'user.fullName',
					width: 150
				}, {
					text: 'تاریخ',
					align: 'center',
					sortable: true,
					value: 'dateTime_Persian',
				}, {
					text: 'از وضعیت (مشتری)',
					align: 'center',
					sortable: true,
					value: 'fromStatus.title',
				}, {
					text: 'به وضعیت (مشتری)',
					align: 'center',
					sortable: true,
					value: 'toStatus.title',
				}, {
					text: 'از وضعیت (نماینده)',
					align: 'center',
					sortable: true,
					value: 'fromAgentStatus.title',
				}, {
					text: 'به وضعیت (نماینده)',
					align: 'center',
					sortable: true,
					value: 'toAgentStatus.title',
				},
			],
			items: [],
		}
	},
	computed: {
		excelFileName() {
			let name = 'لاگ تغییر وضعیت ها'
			name += '.xls'
			return name
		}
	},
	mounted() {
		this.loadData()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get('admin/UserLoanRequestStatusHistory/ListByLoanRequestId/' + this.loanRequestId, {})
				.then(
					response => {
						this.items = response
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loading = false })
		},
	},
}
</script>
<style></style>
